import React from 'react';
import { useParams } from 'react-router-dom';
import MaterialRequirementCreatePage from './MaterialRequirementCreatePage';

/**
 * Material Requirement Edit Page
 * 
 * Wraps the create page with edit mode
 */
export default function MaterialRequirementEditPage() {
  const { id } = useParams<{ id: string }>();
  
  // Pass the id to the create page to enable edit mode
  return <MaterialRequirementCreatePage editId={id} />;
}
